import React, {useEffect} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import {useMenuContext} from "../context/MenuContext";
import {useUserContext} from "../context/UserContext";
import Transition from "./Transition";
import { isMobileDevice } from '../network/constants';


function MainMenu(props) {
    const {menu} = useMenuContext();
    const {user} = useUserContext();
    const {dispatch: menuDispatch} = useMenuContext();

    // set the menu to match the user navigation on user change
    useEffect(
        () => {
            menuDispatch({type: "SET_MENU", menu: user.navigation});
        },
        [menuDispatch, user.navigation]
    );


    return (
        <div className="mt-2">
            <MenuCategory item={menu || {items: []}} level={0} setShowMenu={props.setShowMenu} />
        </div>
    );
}

export default MainMenu;

function toggleCategory(path, isOpen, dispatch) {
    dispatch({type: "TOGGLE_CATEGORY", isOpen, path});
}

function MenuCategory(props) {
    const {dispatch} = useMenuContext();
    const items = props.item.items;

    const paddingStyle = { paddingLeft: `${props.level * 15}px`};
    return (
        <div>
            {/* category */}
            {props.item.label &&
            <div className="text-gray-400">
                <button style={paddingStyle} onClick={() => {toggleCategory(props.item.path, props.item.isOpen, dispatch)}} className="w-full block p-3 text-gray-300 flex items-center border-gray-800 border-b hover:bg-gray-650 hover:text-gray-400">
                    <i className={`mr-1 pi pi-fw  ${props.item.isOpen ? "pi-angle-down": "pi-angle-right"}`}></i>

                    {props.item.label}
                </button>
            </div>
            }

            {/* children */}
            {items &&
                <Transition
                    show={!!props.item.isOpen}
                    enter="transition-opacity ease-out duration-500 transform"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity ease-in duration-100 transform"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div>
                        {Object.keys(items).map(key => items[key].items ?
                            <MenuCategory key={items[key].path} level={props.level + 1} item={items[key]} setShowMenu={props.setShowMenu}/> :
                            <MenuEntry key={items[key].path} level={props.level + 1} item={items[key]} setShowMenu={props.setShowMenu}/>)}
                    </div>
                </Transition>
            }
        </div>
    )
}

function MenuEntry(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = location.pathname === props.item.path;
    const paddingStyle = { paddingLeft: `${props.level * 15}px`};

    function linkClick(path) {
        if(isMobileDevice()) props.setShowMenu(false);
        navigate(path);
    }

    // check if entry is active

    // have some state for the children which one should be open/active and pass setter on to children, so they can call update to this function
    return (
        <div className={`text-gray-400`}>
            <button style={paddingStyle}
                    onClick={() => linkClick(props.item.path)}
                    className={`w-full block p-3 text-gray-300 flex items-center border-gray-800 border-b hover:bg-gray-650 hover:text-gray-400 ${isActive ? "text-blue-600 hover:text-blue-700" : ""}`}>
                {props.item.icon &&
                <i className={`mr-1 pi pi-fw ${props.item.icon}`}></i>
                }
                {props.item.label}
            </button>
        </div>
    );
}